
export class AssessmentSummary {
    constructor(
     
      public programCd: string,
      public etEnrollmentId: Number,
      public statusCd:  String,
      public startDt?: any,
      public dueDt?: any,
      public createdDt?: any,
      public createdBy?: String,
      public id?: any,
      public completedDt?: any,
      public drivingLicenseSw?:  String,
      public testScoreSw?:  String,
      public familyBarrierSw?:  String,
      public personalBarrierSw?:  String,
      public transportationBarrierSw?:  String,
      public empSecurityDeptSw?:  String,
      public empRegistrationSw?:  String,
      public deleteSw?:  String,
      public skillSw?:  String,
      public jobExperienceSw?:  String,
      public highSchoolName?:  string,
      public highSchoolGraduationYearcd?:  string,
      public highestEducationCd?:  string,
      public notes?:any,
      public planId?: Number,
      public recordVersion?:number
    ) {
    }
  }


  



// WEBPACK FOOTER //
// ./src/app/shared/model/AssessmentSummary.model.ts